import { makeAutoObservable } from 'mobx';
import { TAttr, TAxis } from '../Map3d/controller.store';
import { I3Model } from '../Map3d/components/model';
import { sendMessageStore } from '../../modules/unityLayout/sendMessage.store';
import { SceneItemList } from './types';

interface I3ModelWithSize extends I3Model {
  size?: any;
}

class RoomModelControllerStore {
  objectSetting: I3ModelWithSize;
  roomObjects: SceneItemList = [];
  initialValue: I3ModelWithSize;
  showRoomObject: boolean = false;

  currentStep: any = 0;

  endStep: any = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentStep = (step: any) => {
    this.currentStep = step;
  };

  setShowRoomObject = (state: boolean) => {
    this.showRoomObject = state;
  };

  setEndStep = (step: any) => {
    this.endStep = step;
  };

  setInitControllers = (data: any) => {
    const res = {
      position: {
        x: data.coordinate.positionX,
        y: data.coordinate.positionY,
        z: data.coordinate.positionZ,
      },
      rotation: {
        x: data.coordinate.rotationX,
        y: data.coordinate.rotationY,
        z: data.coordinate.rotationZ,
      },
      scale: {
        x: data.coordinate.size,
        y: data.coordinate.size,
        z: data.coordinate.size,
      },
      size: data.coordinate.size,
      public_id: data.publicId,
      path: data.url,
    };
    this.objectSetting = res;
    this.initialValue = res;
  };

  removeById = (id: number) => {
    this.roomObjects = this.roomObjects.filter((item) => item.id !== id);
  };

  setRoomObjects = (data: SceneItemList) => {
    this.roomObjects = data;
  };

  addRoomObjects = (data: any) => {
    this.roomObjects = [...this.roomObjects, data];
  };

  setControllers = (attr: TAttr, axis: TAxis, value: number) => {
    if (attr === 'scale') {
      this.objectSetting = { ...this.objectSetting, size: value };
      this.objectSetting = {
        ...this.objectSetting,
        scale: {
          x: value,
          y: value,
          z: value,
        },
      };
    } else {
      this.objectSetting = {
        ...this.objectSetting,
        [attr]: { ...this.objectSetting[attr], [axis]: value },
      };
    }
    const data = {
      positionX: this.objectSetting.position.x,
      positionY: this.objectSetting.position.y,
      positionZ: this.objectSetting.position.z,
      rotationX: this.objectSetting.rotation.x,
      rotationY: this.objectSetting.rotation.y,
      rotationZ: this.objectSetting.rotation.z,
      size: this.objectSetting.size,
    };
    const sendData = JSON.stringify(data);
    sendMessageStore.setTransformChanging(true);
    sendMessageStore.sendMessage(
      'TransformEditJsEventsHandler',
      'SetTransform',
      sendData,
    );
  };

  updateControllerData = () => {
    this.initialValue = this.objectSetting;
  };

  onDragEnd = () => {
    sendMessageStore.setTransformChanging(false);
  };

  handleUndo = () => {
    sendMessageStore.setTransformChanging(true);
    sendMessageStore.sendMessage('CommandsHistoryEventsHandler', 'Undo');
    sendMessageStore.setTransformChanging(false);
  };

  handleRedo = () => {
    sendMessageStore.setTransformChanging(true);
    sendMessageStore.sendMessage('CommandsHistoryEventsHandler', 'Redo');
    sendMessageStore.setTransformChanging(false);
  };

  resetValue = (attr: TAttr, axis: TAxis) => {
    sendMessageStore.setTransformChanging(true);
    this.setControllers(attr, axis, this.initialValue[attr][axis]);
    sendMessageStore.setTransformChanging(false);
  };
}

export const roomModelControllerStore = new RoomModelControllerStore();
